export default {
	"indexTitle": {
		"title1": "註冊",
		"title2": "登入",
		"title3": "手機下載",
		"title4": "充值",
		"title5": "提現",
		"title6": "體育",
		"title7": "真人",
		"title8": "老虎機",
		"title9": "棋牌",
		"title10": "捕魚",
		"title11": "動物競技",
		"title12": "電競",
		"title13": "彩票",
		"title14": "優惠活動",
		"title15": "手機下載",

		"title16": "訪問歷史",
		"title17": "開始遊戲",
		"title18": "最新消息",
		"title19": "請注意使用支付寶、八達通、tap&go、BOC等類別銀行入款，請必須選擇轉數快並核對收款人英文全名！",
		"title20": "全部優惠",
		"title21": "申請此優惠",
		"title22": "我要遊戲",
		"title23": "餘額",
		"title24": "我的帳戶",
		"title25": "VIP",
		"title26": "充值",
		"title27": "提款",
		"title28": "邀請好友",
		"title29": "任務日誌",
		"title30": "優惠中心",
		"title31": "遊戲記錄",
		"title32": "財務記錄",
		"title33": "公告中心",
		"title34": "推廣分銷",
		"title35": "直屬成員",
		"title36": "我的佣金",
		"title37": "規則說明",
		"title38": "團隊人數",
		"title39": "今日團隊新增",
		"title40": "直屬人數",
		"title41": "今日直屬新增",
		"title42": "今日團隊流水",
		"title43": "今日直屬流水",
		"title44": "推廣收益",
		"title45": "獎金",
		"title46": "下線人數",
		"title47": "預估可以獲得高額獎金",
		"title48": "個人信息",
		"title49": "推薦代碼",
		"title50": "邀請鏈接",
		"title51": "邀請二維碼",
		"title52": "推廣工具",
		"title53": "下載",
		"title54": "我的帳戶",
		"title55": "新密碼",
		"title56": "修改取款密碼",
		"title57": "舊密碼",
		"title58": "必填",
		"title59": "請輸入登入密碼",
		"title60": "確認新密碼",
		"title61": "取消",
		"title62": "更新",
		"title63": "請輸入舊密碼",
		"title64": "請輸入新密碼",
		"title65": "兩次密碼不同",
		"title66": "更新失敗",
		"title67": "登錄密碼",
		"title68": "新取款密碼",
		"title69": "6~10位英文與數字組合(可包含特殊字元)",
		"title70": "確認取款密碼",
		"title71": "請輸入登錄密碼",
		"title72": "請輸入新取款密碼",
		"title73": "存款方式選項",
		"title74": "優惠",
		"title75": "暫無資料",
		"title76": "轉數快",
		"title77": "便利商店增值",
		"title78": "無充值限額",
		"title79": "手續費",
		"title80": "無手續費",
		"title81": "請輸入充值金額",
		"title82": "請輸入付款姓名",
		"title83": "充值贈送",
		"title84": "請選擇",
		"title85": "獲取付款信息",
		"title86": "支付教程",
		"title87": "1.請選擇支付通道後，填入金額，點擊提交。",
		"title88": "2.跳轉第三方支付頁面後，依據頁面程序進行存款並在時限內完成。",
		"title89": "3.支付完成後，等待頁面顯示支付成功信息後，再將頁面關閉，以免發生掉單的情形。",
		"title90": "4.等待第三方平台確認後，系統將自動添加到您的帳號。",
		"title91": "5.支付未到帳？無法支付？請聯繫【在線客服】進行諮詢。",
		"title92": "充值金額",
		"title93": "請記錄以下收款資訊,並匯款",
		"title94": "收款帳號",
		"title95": "收款帳戶名",
		"title96": "收款二維碼",
		"title97": "充值地址",
		"title98": "返回重新輸入",
		"title99": "確認充值",
		"title100": "複製成功！",
		"title101": "開始",
		"title102": "結束",
		"title103": "可查詢當日前31天的資料",
		"title104": "查詢",
		"title105": "存款總計",
		"title106": "提款總計",
		"title107": "優惠總計",
		"title108": "返水記錄",
		"title109": "手動調整記錄",
		"title110": "推薦記錄",
		"title111": "任務獎勵記錄",
		"title112": "*存取數據時可能會延遲，若未找到遊戲記錄，請稍後重試。 總覽資料固定GMT+8時間做加總，只顯示近10日資料",
		"title113": "產品類型",
		"title114": "遊戲",
		"title115": "日期",
		"title116": "總投注",
		"title117": "總有效投注",
		"title118": "總輸贏",
		"title119": "已結算",
		"title120": "投注額",
		"title121": "交易編號",
		"title122": "暫無記錄",
		"title123": "個人資料",
		"title124": "銀行卡資料",
		"title125": "所有錢包",
		"title126": "修改 登錄/取款 密碼",
		"title127": "推薦碼",
		"title128": "玩家帳號",
		"title129": "真實姓名",
		"title130": "手機號碼",
		"title131": "註冊時間",
		"title132": "總金額",
		"title133": "新增銀行卡",
		"title134": "銀行卡號",
		"title135": "開戶人名字",
		"title136": "必須與您的銀行帳戶姓名一致，否則無法進行取款",
		"title137": "收款銀行",
		"title138": "銀行帳號",
		"title139": "請輸入您的銀行帳號",
		"title140": "開戶行網點",
		"title141": "請輸入您的開戶行網點",
		"title142": "確認",
		"title143": "請輸入開戶人名字",
		"title144": "請輸入收款銀行",
		"title145": "請輸入銀行帳號",
		"title146": "請輸入開戶行網點",
		"title147": "倒數時間",
		"title148": "每日存款",
		"title149": "港元以上",
		"title150": "活動點數",
		"title151": "點",
		"title152": "累計登入",
		"title153": "天以上",
		"title154": "已完成",
		"title155": "可領取",
		"title156": "任務準備中",
		"title157": "平台公告",
		"title158": "總計",
		"title159": "申請時間",
		"title160": "審核時間",
		"title161": "待確認",
		"title162": "成功",
		"title163": "失敗",
		"title164": "實際金額",
		"title165": "備註",
		"title166": "訂單號",
		"title167": "更多內容",
		"title168": "VIP等級",
		"title169": "當前等級",
		"title170": "VIP權益說明",
		"title171": "晉級",
		"title172": "條件",
		"title173": "通過",
		"title174": "當前積分",
		"title175": "恭喜達成",
		"title176": "專屬特權",
		"title177": "等級不足",
		"title178": "生日禮金",
		"title179": "領取",
		"title180": "積分歷程",
		"title181": "等級升降",
		"title182": "領取記錄",
		"title183": "提款金額",
		"title184": "稽核總扣除",
		"title185": "提款密碼",
		"title186": "實際提領",
		"title187": "提款金額應介於 1.00 與 10.00 之間",
		"title188": "請先綁定銀行卡",
		"title189": "請輸入提現金額",
		"title190": "請輸入提現密碼",
		"title191": "玩家登錄",
		"title192": "帳號",
		"title193": "密碼",
		"title194": "還未註冊?立即點擊",
		"title195": "忘記帳號",
		"title196": "忘記密碼",
		"title197": "請輸入玩家帳號",
		"title198": "請輸入玩家密碼",
		"title199": "玩家帳戶必須6-12位",
		"title200": "China (中國)",
		"title201": "Hong Kong (香港)",
		"title202": "重新輸入",
		"title203": "立即註冊",
		"title204": "請輸入帳號",
		"title205": "請輸入密碼",
		"title206": "請輸入手機號碼",
		"title207": "每日任務",
		"title208": "輪盤",
		"title209": "推薦進度",
		"title210": "聯繫我們",
		"title211": "關於我們",
		"title212": "登出",
		"title213": "免費註冊",
		"title214": "體育賽事",
		"title215": "真人娛樂",
		"title216": "電子遊戲",
		"title217": "棋牌",
		"title218": "捕魚遊戲",
		"title219": "動物競技",
		"title220": "電子競技",
		"title221": "Android 掃一掃",
		"title222": "iOS 手機掃一掃",
		"title223": "立即遊戲",
		"title224": "活動時間:",


		"title225": "取款密碼",
		"title226": "支付通道",
		"title227": "全部",
		"title228": "玩家充值",
		"title229": "存款記錄",
		"title230": "幫助中心",
		"title231": "存款幫助",
		"title232": "您好,",
		"title233": "銀行卡管理",
		"title234": "每日任務",
		"title235": "累計任務",
		"title236": "期間任務",
		"title237": "簽到任務",
		"title238": "未開通",
		"title239": "修改提款密碼",
		"title240": "玩家賬號",
		"title241": "輪盤點數",
		"title242": "真實姓名",
		"title243": "手機號碼",
		"title244": "生日日期",
		"title245": "註冊時間",
		"title246": "上次登錄密碼",
		"title247": "vip記錄",
		"title248": "提款記錄",
		"title249": "可提款金額",
		"title250": "優惠稽核",
		"title251": "扣除額",
		"title252": "行政費用",
		"title253": "手續費",
		"title254": "優惠金",
		"title255": "常態稽核",
		"title256": "第",
		"title257": "天",
		"title258": "金額",
		"title259": "獲取金額：",
		"title260": "碼量：",
		"title261": "簽到",
		"title262": "已簽到",
		"title263": "總簽到天數：",
		"title264": "總簽到收益：",
		"title265": "當日充值金額：",
		"title266": "當日有效投注：",
		"title267": "要求存款數量：",
		"title268": "要求有效碼量數量：",
		"title269": "轉盤次數：",
		"title270": "次",
		"title271": "今日已完成該任務",
		"title272": "未達標",
		"title273": "首頁",
		"title274": "優惠",
		"title275": "賺錢",
		"title276": "賬戶",
		"title277": "未到簽到天數",

		"title278": "簽到條件",
		"title279": "已達成!",
		"title280": "需先完成身份認證金級",
		"title281": "即可參與此活動",
		"title282": "簽到送獎金",
		"title283": "活動天數共",
		"title284": "總獎金",
		"title285": "選擇幣種",
		"title286": "請輸入英文名字",
		"title287": "賬號最少6位",
		"title288": "銀行賬戶",
		"title289": "最低：",
		"title290": "最高：",
		"title291": "充值額度",
		"title292": "充值額度最低",
		"title293": "充值額度最高",
		"title294": "登錄狀態失效，請重新登錄",
		"title295": "銀行卡名稱",
		"title296": "開戶銀行",
		"title297": "銀行卡賬號",
		"title298": "請輸入6位數字提款密碼",
		"title299": "此動作將把所有余額轉回主錢包，是否繼續？",
		"title300": "取消",
		"title301": "繼續",
		"title302": "提款密碼6位數",
		"title303": "資金回收",
		"title304": "客服",
		"title305": "尚餘打碼量",
		"title306": "實時返水",
		"title307": "領取",
		"title308": "最低充值金額",
		"title309": "下載蘋果版",
		"title310": "支持蘋果",
		"title311": "以上",
		"title312": "下載安卓版",
		"title313": "支持安卓",
		"title314": "微信玩家請用手機瀏覽器",
		"title315": "點擊復製網址",

		"title316": "活動獎品",
		"title317": "我的獎品",
		"title318": "轉盤",
		"title319": "贈送彩金：",
		"title320": "要求真人有效投注數量：",
		"title321": "要求捕魚有效投注數量：",
		"title322": "要求電子有效投注數量：",
		"title323": "要求彩票有效投注數量：",
		"title324": "要求體育有效投注數量：",
		"title325": "要求棋牌有效投注數量：",
		"title326": "要求其他有效投注數量：",
		"title327": "百家樂",

		"title328": "實時返水",
		"title329": "點擊領取",
		"title330": "元",
		"title331": "真人返水金額：",
		"title332": "體育返水金額：",
		"title333": "電子返水金額：",
		"title334": "棋牌返水金額：",
		"title335": "領取說明",
		"title336": "領取時間為16:00:00-23:59:59,如未在此時間段內領取則清零",
		"title337": "僅提供14天內交易資料查詢",
		"title338": "捕魚返水金額：",
		"title339": "電競返水金額：",
		"title340": "動物電競返水金額：",
		"title341": "主錢包",
		"title342": "遊戲錢包",
		"title343": "線路選擇",
		"title344": "客服（線路一）",
		"title345": "客服（線路二）",
		"title346": "有效投注",
		"title347": "不參與活動",
		"title348":"簽到活動",
		"title349":"輪盤抽獎",
		"title350":"紅包活動",
		"title351":"選單",
		"title352":"返回",
		"title353":"語言",
		"title354":"法定貨幣",
		"title355":"加密貨幣",
		"title356":"存款幣種",
		"title357":"存款類型",
		"title358":"銀行轉帳",
		"title359":"轉數快",
		"title360":"熱門",
		"title361":"選擇活動",
		"title362":"不參與活動",
		"title363":"選擇網路",
		"title364":"首次存款之會員可至獎金介面申請首存獎金",
		"title365":"存款地址",
		"title366":"複製地址",
		"title367":"全自動到帳 匯率",
		"title368":"收款機構",
		"title369":"訂單編號",
		"title370":"聯絡資訊",
		"title371":"電話驗證",
		"title372":"已驗證",
		"title373":"驗證",
		"title374":"變更登入密碼",
		"title375":"定期變更密碼，以保持密碼的唯一性和安全性。",
		"title376":"變更支付密碼",
		"title377":"請輸入舊密碼",
		"title378":"6 位數字組合（不能輸入其他字元）",
		"title379":"電話驗證",
		"title380":"顯示所有",
		"title381":"收起",
		"title382":"一般獎金",
		"title383":"輪盤點數",
		"title384":"已領取獎金總額",
		"title385":"詳細資訊",
		"title386":"當前可領取",
		"title387":"領取獎勵",
		"title388":"紅包獎金",
		"title389":"高達",
		"title390":"簽到獎金",
		"title391":"每日真人獎金",
		"title392":"每日體育獎金",
		"title393":"每日電子獎金",
		"title394":"每日棋牌獎金",
		"title395":"每日捕魚獎金",
		"title396":"每日電競獎金",
		"title397":"每日其他遊戲獎金",
		"title398":"每日輪盤點數",
		"title399":"當日存款",
		"title400":"當日流水",
		"title401":"隨機紅包",
		"title402":"優惠規則與條款",
		"title403":"紅包申請：此活動當日存款金額",
		"title404":"流水金額",
		"title405":"當日可以在活動頁面點擊立即領取。",
		"title406":"此活動領取彩金，僅1倍流水提款。",
		"title407":"此活動每位玩家每天可申請一次，隨機紅包金額最高",
		"title408":"每位玩家僅能註冊一個賬戶，如註冊多個賬戶參與活動則被視為多賬戶套利，平台將禁用封鎖該賬戶。",
		"title409":"WG CLUB保留對此活動做出更改，終止的權利，並享受最終解釋權。",
		"title410":"本平台特別推出每日簽到獎金制度，只要您完成要求的條件，即可獲得簽到資格，累積下來驚喜更多，逢星期一00:00重置簽到天數！",
		"title411":"只要參與並達成條件，即可於每日獲得額外輪盤點數，讓您遊戲精彩不停!",
		"title412":"只要參與並達成條件，即可於每日獲得額外真人獎金，讓您遊戲精彩不停！",
		"title413":"只要參與並達成條件，即可於每日獲得額外體育獎金，讓您遊戲精彩不停！",
		"title414":"只要參與並達成條件，即可於每日獲得額外電子獎金，讓您遊戲精彩不停！",
		"title415":"只要參與並達成條件，即可於每日獲得額外棋牌獎金，讓您遊戲精彩不停！",
		"title416":"只要參與並達成條件，即可於每日獲得額外捕魚獎金，讓您遊戲精彩不停！",
		"title417":"只要參與並達成條件，即可於每日獲得額外電競獎金，讓您遊戲精彩不停！",
		"title418":"已連續簽到",
		"title419":"賭場",
		"title420":"影城",
		"title421":"立即遊玩",
		"title422":"今天",
		"title423":"昨天",
		"title424":"近7天",
		"title425":"近30天",
		"title426":"一次顯示：100 筆， 總筆數: ",
		"title427":"類型",
		"title428":"時間",
		"title429":"未結算",
		"title430":"已取消",
		"title431":"自訂",
		"title432":"狀態",
		"title433":"已有帳戶",
		"title434":"優惠相關",
		"title435":"記住帳號及密碼",
		"title436":"近30天已領取優惠總額",
		"title437":"代理佣金",
		"title438":"推薦代碼",
		"title439":"佣金獎勵",
		"title440":"領取紀錄",
		"title441":"昨日好友有效投注",
		"title442":"可領取佣金",
		"title443":"存款提現有什麼要求？",
		"title444":"存款最低金額 100HKD，提款最低金額 100HKD。代理支持 USDT 提款金額需達 10000 以上，並聯絡客服綁定 USDT 提款。佣金需一倍有效投注方可提款。",
		"title445":"推薦獎金如何計算？",
		"title446":"推薦獎金計算方式，邀請下線註冊並投注即可獲取下線會員的 0.3% 返水。計算方式如下：下線會員投注金額為 5000000，則可以領取佣金為 5000000*0.3%= 15000 佣金",
		"title447":"紅利獎金多久結算一次？",
		"title448":"代理佣金即時結算，下線會員投注即刻可以獲取佣金。",
		"title449":"每日动物電競獎金",
		"title450":"只要参与并达成条件，即可于每日获得额外动物電競奖金，让您游戏精彩不断！",
		"title451": "升至",
		"title452": "規則",
		"title453": "等級",
		"title454": "晉級獎金",
		"title455": "週禮金",
		"title456": "月禮金",
		"title457": "轉運金",
		"title458": "VIP等級制度",
		"title459": "保級經驗值",
		"title460": "升級經驗值",
		"title461": "晉升標準",
		"title462": "會員達到相應級別的有效打碼量要求，系統將會自動判斷並晉級相應vip等級。（每晉級相應vip等級有效打碼量將重新計算）。",
		"title463": "保級要求",
		"title464": "會員在達到某VIP等級後，60天內需要完成保級有效打碼量要求（當前等級晉升所需有效打碼量的一半等於保級有效打碼量）。如果在此期間完成晉升，保級要求重新按照當前等級計算。",
		"title465": "降級標準",
		"title466": "會員在60天內，沒有完成相應的保級要求，系統將會自動降級一個等級（每降至相應VIP等級有效投注額將重新計算），相應的優惠也會隨之調整至降級後的等級。",
		"title467": "晉級禮金",
		"title468": "晉級禮金在會員晉升等級後，即可在VIP頁面領取晉級彩金，每個級別的晉級禮金僅能獲得1次，晉級禮金需完成1倍打碼量即可提款。",
		"title469": "VIP週紅包",
		"title470": "VIP紅包每週即可領取一次，紅包金額根據當前等級可領取相應的金額，逢週一00:00更新逾期則無法領取上週紅包彩金，紅包1倍有效打碼量即可提款，每週限參與一次。",
		"title471": "VIP月紅包",
		"title472": "VIP紅包每月即可領取一次，紅包金額根據當前等級可領取相應的金額，逢一號00:00更新逾期則無法領取上月紅包彩金，紅包1倍有效打碼量即可提款，每月限參與一次。",
		"title473": "VIP俱樂部",
		"title474": "複製",
		"title475": "邀請好友",
		"title476": "業績查詢",
		"title477": "該獎勵已領取",
		"title478": "本週已領取",
		"title479": "本月已領取",
		"title480": "本日已領取",
		"title481": "帳號（請輸入6-12個英文字母和數字）",
		"title482": "密碼（6~16個字符）",
		"title520": "活動詳情",
		"title521": "領取",
		"title522": "每日簽到獎金制度，只要您完成要求的條件，即可獲得簽到獎金。",
		"title523": "每日簽到逢星期一00:00重置簽到日數。",
		"title524": "抽獎次數如何獲取？",
		"title525": "1.輪盤按每日充值自動派發。",
		"title526": "2.輪盤點數詳情可以查看優惠中心。",
		"title527": "⚠️ 注意：",
		"title528": "1.輪盤點數需當天使用。",
		"title529": "2.當天剩餘的輪盤點數不保留，隔天00:00重置。",
		"title530": "3.您獲得輪盤獎金，需完成 1 倍有效投注後即可提款",
		"title531": "彩金庫",
		"title532": "餘額寶",
		"title533": "彩金隨時領",
		"title534": "閒錢享收益",
		"title535": "總金額 (HK$)",
		"title536": "年利率",
		"title537": "轉入",
		"title538": "領取",
		"title539": "轉出",
		"title540": "當前收益",
		"title541": "總計彩金",
		"title542": "累計收益",
		"title543": "明細詳情",
		"title544": "餘額寶規則",
		"title545": "收益明細",
		"title546": "領取記錄",
		"title547": "轉出記錄",
		"title548": "轉入記錄",
		"title549": "收益",
		"title550": "暫無記錄",
		"title551": "中心錢包餘額",
		"title552": "餘額寶餘額",
		"title553": "請輸入金額",
		"title554": "確認",
		"title555": "利息規則\n• 主賬戶資金需滿足提款碼量後才能轉入餘額寶。\n• 按年利率計算，每小時為一個結算週期，收益公式如下：\n餘額寶金額 × 年利率 ÷ 365 ÷ 24 = 每小時收益。\n• 需存入 2 小時後才開始計算收益，轉出彩金獎勵不受影響。\n• 單次存入的最高結算週期為 12 小時，超過 12 小時需重新存入才能繼續計算利息。\n• 以 365 % 年利率為例，若餘額寶金額為 100,000 HKD，則12小時的利息收益約為 500 HKD。\n\n轉出規則\n獎勵比例：\n• 每筆從餘額寶轉出至主賬戶才獲得1%彩金獎勵，每天最多2次，1%獎勵上限為388 HKD。\n轉出要求：\n• 轉出至主帳戶後，需完成 「轉出金額 + 彩金」的 1 倍打碼量方可提款。",
		"title556": "操作失敗，請稍後重試",
		"title557": "主錢包餘額(HK$)",
		"title558": "利息寶錢包(HK$)",
		"title559": "轉入金額",
		"title560": "提現密碼",
		"title561": "主賬戶金額需完成打碼量並滿足提款條件後，方可轉入利息寶。可通過打碼量檢查是否符合轉入條件。",
		"title562": "轉出",
		"title563": "全部餘額",
		"title564": "未領取收益",
		"title565": "轉出金額",
		"title566": "贈送金額",
		"title567": "彩金獎勵規則：",
		"title568": "1.轉出贈送{rate}%，2次/天",
		"title569": "2.轉出後「本金+彩金」需要完成1倍打碼量",
		"title572": "到賬合計",
		"title573": "轉出贈送",
		"title574": "彩金庫",
		"title575": "可領取",
		"title576": "進行中",
		"title577": "已領取",
		"title578": "已過期",
		"title579": "積分中心",
		"title580": "優先打碼中",
		"title581": "刷新",
		"title582": "獎金",
		"title583": "首存最高贈送150% - 打碼領取",
		"title584": "所需打碼量",
		"title585": "打碼開始時間",
		"title586": "打碼截止時間",
		"title587": "有效打碼遊戲",
		"title588": "已完成",
		"title589": "當前打碼",
		"title590": "還需",
		"title591": "分段獎勵領取",
		"title592": "總獎勵",
		"title593": "已領取",
		"title594": "第",
		"title594b": "檔",
		"title595": "進度 ≥",
		"title596": "已達標，可立即領取該檔獎勵",
		"title597": "領取獎勵",
		"title598": "尚未達到進度要求",
		"title599": "未達標",
		"title600": "暫無進行中的彩金",
		"title601": "真人(計20%)、體育(計100%)、棋牌(計100%)、電子(計100%)、電競(計100%)、捕魚(計100%)",
		"title602": "暫無可領取彩金",
		"title603": "暫無已領取記錄",
		"title604": "暫無已過期記錄",
		"title605": "積分中心即將開放",
		"title606": "設為優先打碼",
		"title607": "累計領取金額",
		"title608": "沒有更多了",
		"title609": "VIP獎金",
		"title610": "人工優惠",
		"title611": "所獲獎勵",
		"title612": "熱門遊戲",
		"title570": "請輸入6位提現密碼",
		"title571": "暫無可轉出餘額",
		"title483": "請輸入英文姓名（可含空格）",
		"title484": "請輸入手機號碼",
		"title485": "提款密碼（6位數字組成）",
		"title486": "請輸入舊提款密碼",
		"title487": "驗證碼",
		"title487Err": "請輸入驗證碼",
		"title488": "獲取驗證碼",
		"title489": "帳號登入",
		"title490": "手機登入",
		"title491": "忘記密碼",
		"title492": "設置新密碼",
		"title493": "確認修改",
		"title494": "已領取佣金獎勵",
		"title495": "刪除",
		"title496": "刪除銀行卡",
		"title497": "取消",
		"title498": "確認刪除",
	},

};